import { apiDelete, apiGet, apiPatch, apiPost } from './client';

function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function getPublicVacancies({ query, track_label, limit = 20, offset = 0 } = {}) {
  return apiGet(`/vacancies${buildQuery({ query, track_label, limit, offset })}`);
}

export function applyToVacancy(vacancyId) {
  return apiPost(`/vacancies/${vacancyId}/apply`, {});
}

export function getTeamVacancies(teamId) {
  return apiGet(`/teams/${teamId}/vacancies`);
}

export function createTeamVacancy(teamId, payload) {
  return apiPost(`/teams/${teamId}/vacancies`, payload);
}

export function updateTeamVacancy(teamId, vacancyId, payload) {
  return apiPatch(`/teams/${teamId}/vacancies/${vacancyId}`, payload);
}

export function deleteTeamVacancy(teamId, vacancyId) {
  return apiDelete(`/teams/${teamId}/vacancies/${vacancyId}`);
}

export function approveTeamVacancyApplication(teamId, vacancyId, userId) {
  return apiPost(`/teams/${teamId}/vacancies/${vacancyId}/applications/${userId}/approve`, {});
}

export function declineTeamVacancyApplication(teamId, vacancyId, userId) {
  return apiPost(`/teams/${teamId}/vacancies/${vacancyId}/applications/${userId}/decline`, {});
}
